// Authentication, throttling and transport failures say nothing about an
// earlier attempt. Keep its request ID so a later retry can read the receipt.
export function definitiveOperationRejection(error){
 return [400,404,409,410,412,413,415,422].includes(error?.status);
}

export function rememberPendingOperation(key,command,storage){
 try{
  const target=storage||globalThis.sessionStorage;
  if(command)target.setItem(key,JSON.stringify(command));else target.removeItem(key);
  return true;
 }catch{return false;}
}
